// Spec 2026-10-28 §7.3: Better / No change / Worse and hub/keeper labels.
export function verdictBadge(view) {
  if (!view || !view.verdict) return null;
  const map = {
    BETTER: { text: `Better (+${Math.round(Number(view.score) * 10) / 10})`, className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' },
    NO_CHANGE: { text: 'No change', className: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200' },
    WORSE: { text: 'Worse', className: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' },
  };
  return map[view.verdict] || null;
}

export function roleLabel(role, info) {
  // I2: the share the distribution score uses — the hub's own measure, or the portfolio share below the floor.
  if (role === 'HUB' && info?.shareUsed != null) {
    const pct = Math.round(Number(info.shareUsed));
    return info.portfolio ? `hub · ~${pct}% (portfolio)` : `hub · ${pct}% in-region`;
  }
  return { HUB: 'hub', KEEPER: 'keeper', MIXED: 'mixed' }[role] || '—';
}
